<template>
  <v-container fluid class="claim-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/my/claim/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="claims-table"
              show-select
              single-select
              item-key="_id"
              sort-desc
              sort-by="claimnum"
              :footer-props="footer"
              :headers="headers"
              :items="claims"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Claim?
                    </v-card-title>
                    <v-card-text>
                      {{ deleteclaim.claimnum }} 
                      {{ deleteclaim.claimname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteclaim)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.employeeid="{ item }">
                <v-avatar v-if="employees.length>0 && employees.find(employee=>employee._id == item.employeeid)['employeeimage']!==''" size="40">
                  <img v-bind:src="employees.find(employee=>employee._id == item.employeeid)['employeeimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ employees.length>0 ? employees.find(employee=>employee._id == item.employeeid)['employeename'][0].toUpperCase() : '' }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ employees.length>0 ? employees.find(employee=>employee._id == item.employeeid)['employeename'] : '' }} </span>
              </template>
              <template v-slot:item.claimnum="{ item }">
                <p class="two-line">{{ item.claimtype  }}</p>
                <p class="two-line">{{ item.claimnum  }}</p>
                <p class="two-line">{{ new Date(item.claimdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.claimaddress="{ item }">
                <p class="two-line">{{ item.claimaddress }}</p>
                <p class="two-line">{{ regions.length>0 ? regions.find(region=>region._id == item.regionid)['regionname'] : ''  }} - {{ townships.length>0 ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
              </template>
              <template v-slot:item.claimtotal="{ item }">
                {{ item.claimtotal.toLocaleString('en-SG') }}
              </template>
              <template v-slot:item.claimstatus="{ item }">
                <v-chip
                  :color="item.claimstatus=='Approve' ? 'successConst white--text' : item.claimstatus=='Reject' ? 'error white--text' : item.claimstatus=='Completed' ? 'greyTint white--text' : 'primaryConst white--text'"
                  small>
                  {{ item.claimstatus }}
                </v-chip>
                <p class="two-line" style="font-size: x-small;">{{ item.claimreason }}</p>
              </template>
              <template v-slot:item.claimtotal="{ item }">
                {{ item.claimtotal!=null ? item.claimtotal.toFixed(2) : '' }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
<!--               <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="item.claimstatus=='New'"  icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn v-if="item.claimstatus=='New'" icon color="primary" @click="editClaimStatusDialog(item)">
                  <v-icon>mdi-text-box-edit-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.claimstatus=='New'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template> -->
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MyClaimList',
  data() {
    return {
      config,
      dialog: false,
      showEditDialog: false,
      deleteclaim: {},
      claimstatus: {},
      claims: [],
      headers: [
        { text: 'Claim', value: 'claimnum', sortable: false },
        { text: 'Name', value: 'claimname' },
        { text: 'Amount', value: 'claimtotal' },
        { text: 'Employee', value: 'employeeid' },
        { text: 'Status', value: 'claimstatus', align: 'center', 'width': '10%' },
        { text: 'Actions', value: 'actions', sortable: false, 'width': '15%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('Employee', ['employees']),
    ...mapState('MyAccount', ['isReceiving', 'isDeleting']),
  },
  async created () {
    this.claims = await this.getMyClaimsRequest();

    if(this.regions.length==0) this.getRegionsRequest();
    if(this.townships.length==0) this.getTownshipsRequest();
    if(this.employees.length==0) this.getEmployeesRequest();
  },
  methods: {
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions('MyAccount', ["getMyClaimsRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    checkError1(){
      if(!this.claimstatus.claimstatus){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.claimstatus.claimreason){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    editItem(item) {
      this.$router.push({ name: 'ClaimEdit', params: item })
    },
    printItem(item) {
      this.$router.push({ name: 'ClaimPrint', params: item })
    },
    viewItem(item) {
      this.$router.push({ name: 'ClaimView', params: item })
    },
    deleteItem(item) {
      this.deleteClaimRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteclaim = {
        _id: item._id,
        claimnum: item.claimnum,
        claimname: item.claimname,
      }
    },
    editClaimStatusDialog(item) {
      this.claimstatus = {claimid: item._id};
      this.showEditDialog = true;
    },
    async editClaimStatus() {
      if(!this.checkError1()){return}
      this.showEditDialog = false;
      await this.updateClaimStatusRequest(this.claimstatus);
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
